#global $, _
class StickyHandler

  constructor: (@element, @container, @elementOffset) ->
    if @element.length
      @container = @container || $('body')
      @window ?= $(window)
      @document = $(document)
      @parent = @element.parent()
      @sibling = @parent.next()
      @firstTick = true
      @elementOffset ?= 0
      @lastCss = {}
      @scrollTop = @window.scrollTop()
      @attachEvents()
      @updatePosition()

  updateDimensions: () =>
    @windowHeight = @window.height()
    @elementHeight = @element.height()
    @elementWidth = @element.outerWidth()
    @parentPadding = @parent.outerWidth() - @elementWidth
    @offsetLeft = @sibling.offset().left + @sibling.outerWidth() + @parentPadding - @window.scrollLeft()
    @containerBottomPosition = @container.offset().top + @container.height()
    @scrollTop = @window.scrollTop()
    @elementTop = @parent.offset().top - @elementOffset
    @elementBottomPosition = @scrollTop + @elementHeight

  resize: () =>
    @firstTick = true
    @updatePosition()

  scroll: () =>
    @firstTick = false
    @updatePosition()

  updatePosition: () =>
    @updateDimensions()
    @css = @getCss()
    if not _.isEqual @css, @lastCss
      @updateCss()
      @lastCss = _.clone @css

  updateCss: () =>
    @element.css(@css)

  getCss: () =>
    if @isWindowSmallerThanElement() or @shouldBeRelative() or @isFixedPositionOverrideRequired()
      @getRelativeCss()
    else if @shouldBeAbsolute()
      @getAbsoluteCss()
    else
      @getFixedCss()

  getRelativeCss: () =>
    'position': 'relative'
    'top': if (@isFixedPositionOverrideRequired() and !@isWindowSmallerThanElement()) then  @scrollTop - @elementTop else 0
    'width': ''
    'left': ''
    'transform': 'translate3d(0px,0px,0px)'
    '-webkit-overflow-scrolling': 'touch'
    'overflow': 'hidden'

  getAbsoluteCss: () =>
    'position': 'absolute'
    'top': @containerBottomPosition - @elementHeight - @elementTop
    'width': @elementWidth
    'left': @parentPadding
    'transform': 'translate3d(0px,0px,0px)'
    '-webkit-overflow-scrolling': 'touch'
    'overflow': 'hidden'

  getFixedCss: () =>
    'position': 'fixed'
    'top': @elementOffset
    'width': @elementWidth
    'left': @offsetLeft
    'transform': 'translate3d(0px,0px,0px)'
    '-webkit-overflow-scrolling': 'touch'
    'overflow': 'hidden'

  isFixedPositionOverrideRequired: () =>
    @shouldBeFixed() and (@firstTick or @windowHasHorizontalScroll())

  shouldBeRelative: () =>
    @scrollTop <= @elementTop

  shouldBeAbsolute: () =>
    @elementBottomPosition > @containerBottomPosition

  shouldBeFixed: () =>
    not (@shouldBeRelative() or @shouldBeAbsolute())

  isWindowSmallerThanElement: () =>
    @windowHeight < @elementHeight

  windowHasHorizontalScroll: () =>
    @window.scrollLeft() != 0

  attachEvents: () =>
    if window.addEventListener
      window.addEventListener 'scroll', @scroll, false
      window.addEventListener 'resize', @resize, false
    else if window.attachEvent
      window.attachEvent 'onscroll', @scroll
      window.attachEvent 'onresize', @resize

    $(document.body).on 'modal-open', @scroll

module.exports = StickyHandler



// WEBPACK FOOTER //
// ./modules/deal/desktop_2016/frontend/sticky_handler.coffee